import React from 'react';
import { Input } from '../../ui/input';
import CommonFormFields from './CommonFormFields';

/**
 * Business Courier / Document Transport Form
 * Used for both business_courier and document_transport form types
 */
const BusinessCourierForm = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <CommonFormFields formData={formData} setFormData={setFormData} />
      
      <hr className="my-4" />
      <div className="p-4 bg-[#D4AF37]/10 rounded-xl">
        <p className="text-[#D4AF37] text-sm">
          For Business Courier and Document Transport, please contact us directly or use our standard booking flow for faster service.
        </p>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Service Description *</label>
        <textarea
          value={formData.request_description || ''}
          onChange={(e) => updateField('request_description', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[100px]"
          placeholder="Describe your courier/document transport needs"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Pickup Address *</label>
        <Input
          value={formData.pickup_address || ''}
          onChange={(e) => updateField('pickup_address', e.target.value)}
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Delivery Address *</label>
        <Input
          value={formData.delivery_address || ''}
          onChange={(e) => updateField('delivery_address', e.target.value)}
          required
        />
      </div>
    </div>
  );
};

export default BusinessCourierForm;
